import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import { api, formatApiError } from "../../lib/api";

const iso = (d) => d.toISOString().slice(0, 10);
export function monthRange() {
  const n = new Date();
  return [iso(new Date(n.getFullYear(), n.getMonth(), 1, 12)), iso(new Date(n.getFullYear(), n.getMonth() + 1, 0, 12))];
}

// Date-range picker + one-click CSV download of paid / prepaid payments.
export function ExportPaymentsButton({ url, from, to, testid, label = "Download payments" }) {
  const [range, setRange] = useState(() => (from && to ? [from, to] : monthRange()));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (from && to) setRange([from, to]); }, [from, to]);

  const download = async () => {
    if (range[0] > range[1]) { toast.error("Start date must be before end date"); return; }
    setBusy(true);
    try {
      const r = await api.get(url, { params: { from_date: range[0], to_date: range[1] }, responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = `${testid}_${range[0]}_to_${range[1]}.csv`;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const inp = "h-9 px-2 border border-[#E5E2D9] rounded-md text-xs bg-white";
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={testid}>
      <input type="date" value={range[0]} onChange={e => setRange([e.target.value, range[1]])}
             className={inp} data-testid={`${testid}-from`}/>
      <span className="text-xs text-[#8A8780]">to</span>
      <input type="date" value={range[1]} onChange={e => setRange([range[0], e.target.value])}
             className={inp} data-testid={`${testid}-to`}/>
      <button onClick={download} disabled={busy} data-testid={`${testid}-btn`}
              className="h-9 px-3 rounded-md bg-[#1A1A1A] hover:bg-black text-white text-xs font-medium inline-flex items-center gap-1.5 disabled:opacity-60">
        <DownloadSimple size={13}/>{busy ? "Preparing…" : label}
      </button>
    </div>
  );
}
